import { getApiData, sendApiData } from "./client";
import type { SceneSnapshot } from "./templates";
import type { PaginationResult } from "./types";

export type CommunityTopic = {
  id: string;
  name: string;
  popular: boolean;
  coverUrl?: string | null;
};

export type CommunityNote = {
  id: string;
  title: string;
  content?: string | null;
  topic?: string | null;
  type: string;
  authorId?: string | null;
  authorName?: string | null;
  authorAvatarUrl?: string | null;
  likeCount?: number;
  collectCount?: number;
  browseCount?: number;
  commentCount?: number;
  publishedAt?: string | null;
  createdAt?: string;
  coverUrl?: string | null;
  /** 640px webp 封面；后端未部署该字段时为空。 */
  coverThumbUrl?: string | null;
  imageUrls?: string[];
  sceneTemplateId?: string | null;
  hasScene?: boolean;
  scene?: SceneSnapshot | null;
  liked?: boolean;
  collected?: boolean;
};

export type CommunityReactionState = {
  liked: boolean;
  collected: boolean;
  likeCount: number;
  collectCount: number;
};

export type CommunityComment = {
  id: string;
  noteId: string;
  noteTitle?: string | null;
  userId?: string | null;
  userName?: string | null;
  avatarUrl?: string | null;
  content: string;
  rootCommentId?: string | null;
  replyCommentId?: string | null;
  createdAt?: string;
};

export type CommunityNotePayload = {
  title: string;
  content?: string;
  topic?: string;
  sceneTemplateId?: string;
  coverDataUrl?: string;
  imageDataUrls?: string[];
};

export type CommunityCommentPayload = {
  noteId: string;
  content: string;
  rootCommentId?: string;
  replyCommentId?: string;
};

export const communityApi = {
  topics: (params?: { page?: number; pageSize?: number; popular?: boolean; name?: string }) =>
    getApiData<PaginationResult<CommunityTopic>>("/client/community/topics", { params }),
  notes: (params?: { page?: number; pageSize?: number; title?: string; type?: string; topic?: string; sort?: string }) =>
    getApiData<PaginationResult<CommunityNote>>("/client/community/notes", { params }),
  note: (id: string) => getApiData<CommunityNote>(`/client/community/notes/${id}`),
  collections: () => getApiData<PaginationResult<CommunityNote>>("/client/community/collections"),
  toggleLike: (id: string) => sendApiData<CommunityReactionState>("post", `/client/community/notes/${id}/like`),
  toggleCollect: (id: string) => sendApiData<CommunityReactionState>("post", `/client/community/notes/${id}/collect`),
  publish: (data: CommunityNotePayload) =>
    sendApiData<CommunityNote>("post", "/client/community/notes", data, { timeout: 30000 }),
  comments: (params?: { page?: number; pageSize?: number; noteId?: string }) =>
    getApiData<PaginationResult<CommunityComment>>("/client/community/comments", { params }),
  createComment: (data: CommunityCommentPayload) =>
    sendApiData<CommunityComment>("post", "/client/community/comments", data),
};
